export default __webpack_public_path__ + "static/media/post7.1ddb8943.png";